import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import { shouldShowObsequesChildren } from "../../../obseques";
import Activity from "./Activity";
import Adherent from "./Adherent";
import Beneficiary from "./Beneficiary";
import Children from "./Children";
import Contact from "./Contact";
import Contract from "./Contract";
import Information from "./Information";
import LegalProtection from "./LegalProtection";
import Partner from "./Partner";
import Payment from "./Payment";

export const generateFormMap = (_subscription, initialValues = {}) => ({
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.CONTRACT]: Contract,
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.ADHERENT]: Adherent,
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.ACTIVITY]: Activity,
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.CONTACT]: Contact,
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.PARTNER]: Partner,
  ...(shouldShowObsequesChildren(initialValues)
    ? {
        [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.CHILDREN]: Children,
      }
    : {}),
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.LEGAL_PROTECTION]:
    LegalProtection,
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.BENEFICIARY]: Beneficiary,
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.INFORMATION]: Information,
  [SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.PAYMENT]: Payment,
});
